import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CartService } from '@pisci/data-cart';

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.scss'],
})
export class CompleteComponent implements OnInit {
  cancelled = false;
  constructor(private cartService: CartService, private route: ActivatedRoute) {
    route.params.subscribe((params) => {
      if (params['name'] == 'cancel') {
        this.cancelled = true;
      } else {
        this.cancelled = false;
        this.cartService.clearCart();
      }
    });
  }

  ngOnInit(): void {}
}
